import { AsyncPropSelector, ApiProgressLoader } from '@nile/components';
import { DisabledTag } from '@nile/mangifera/src/Pebbles/TicketContainer';
import { Button, ButtonGroup, Popover } from '@superops/ui-design-system';
import { Edit } from '@styled-icons/material/Edit';
import React, { useCallback, useState } from 'react';
import styled from 'styled-components';
import { EditIcon } from '@nile/components/src/Icons';

const Wrap = styled.div`
  display: flex;
  align-items: center;
  .edit-actions {
    visibility: hidden;
    cursor: pointer;
  }
  padding-left: 8px;
  padding-right: 8px;
  max-width: 100%;
`;

const Field = styled.div`
  min-width: 200px;
  max-width: 250px;
  flex-grow: 1;
  padding-right: 10px;
  padding-left: 10px;
  margin-top: 8px;
  margin-bottom: 8px;
  .Polaris-ButtonGroup {
    margin-top: 12px;
  }
`;


function DependantCell(props) {
  const { cell, params, _ticket } = props;
  const allProps = params || cell.column;
  const { editable, parentField, dependantField, actions, accessor } = allProps;
  const ticket = _ticket || cell.row.original;
  const [popoverActive, setPopoverActive] = useState(false);
  const [updatedProperties, setUpdatedProperties] = useState({});
  const [apiProgress, setApiProgress] = useState(false);
  const [apiResult, setApiResult] = useState('');
  const togglePopoverActive = useCallback(() => {
    setPopoverActive(!popoverActive);
  });

  const activator = <EditIcon onClick={() => togglePopoverActive()} />;

  const updateSelectedProperties = (key, value) => {
    setUpdatedProperties({
      ...updatedProperties,
      [key]: value
    });
  };

  const updateProperties = (properties) => {
    setUpdatedProperties({
      ...updatedProperties,
      ...properties
    });
  };

  const updateSelection = (f, val) => {
    let serialisedValue = null;
    let updatedProperty = {};
    if (f.isCustom) {
      updateSelectedProperties('customFields', val);
    } else {
      switch (f.name) {
        case 'techGroup':
          serialisedValue = { groupId: val.groupId, name: val.name };
          break;
        case 'technician':
          serialisedValue = { userId: val.userId };
          break;
        default:
          serialisedValue = val.name;
      }

      updatedProperty = { [f.name]: serialisedValue };
      if (parentField.name === f.name) {
        updatedProperty = {
          ...updatedProperty,
          [dependantField.name]: null
        };
      }
      updateProperties(updatedProperty);
    }
  };

  const setApiComplete = (state) => {
    if (props.showProgress) {
      setApiProgress(false);
      setApiResult(state);
    }
    setTimeout(() => {
      setApiResult('');
    }, 2000);
  };

  const getTag = () => {
    const parentFieldValue = updatedProperties.hasOwnProperty(parentField.name)
      ? updatedProperties[parentField.name]
      : ticket[parentField.name];
    const defaultParentValue = parentFieldValue
      ? {
          name: parentFieldValue,
          label: parentFieldValue,
          value: parentFieldValue
        }
      : '';
    const dependantFieldValue = updatedProperties.hasOwnProperty(
      dependantField.name
    )
      ? updatedProperties[dependantField.name]
      : ticket[dependantField.name];
    const defaultDependantValue = dependantFieldValue
      ? {
          name: dependantFieldValue,
          label: dependantFieldValue,
          value: dependantFieldValue
        }
      : '';
    return (
      <Field>
        <AsyncPropSelector
          defaultValue={defaultParentValue}
          updateSelection={updateSelection}
          ticket={ticket}
          field={parentField}
        />
        <AsyncPropSelector
          isDependant
          parent={parentField}
          parentValue={parentFieldValue}
          defaultValue={defaultDependantValue}
          updateSelection={updateSelection}
          ticket={ticket}
          field={dependantField}
        />
        <div className="mt10">
          <ButtonGroup>
            <Button
              onClick={() => {
                togglePopoverActive();
                setUpdatedProperties({});
              }}
            >
              Cancel
            </Button>
            <Button
              primary
              onClick={() => {
                if (props.showProgress) {
                  setApiProgress(true);
                }
                actions.save &&
                  actions.save(
                    updatedProperties,
                    ticket,
                    props.data,
                    setApiComplete
                  );
                togglePopoverActive();
                setUpdatedProperties({});
              }}
            >
              Save
            </Button>
          </ButtonGroup>
        </div>
      </Field>
    );
  };
  //TODO :: render value in a proper way for NA - vignesh
  const displayVal = cell
    ? props.column.subAccessor
      ? cell.value[props.column.subAccessor]
      : cell.value
      ? cell.value.name || cell.value
      : ''
    : ticket[accessor]
    ? ticket[accessor]
    : '';
  return !popoverActive ? (
    <Wrap className={`${editable ? 'editable-cell' : 'cell'}`}>
      <div className="ellipsis" title={displayVal}>
        {displayVal ? displayVal : <DisabledTag>NA</DisabledTag>}
      </div>
      {editable && <div className="edit-actions">{activator}</div>}
      {apiProgress && <ApiProgressLoader isLoading />}
      {apiResult && <ApiProgressLoader isSuccess={apiResult === 'success'} />}
    </Wrap>
  ) : (
    <Wrap className="editable-cell">
      <div className="ellipsis" title={displayVal}>
        {displayVal ? displayVal : <DisabledTag>NA</DisabledTag>}
      </div>
      <Popover
        activator={activator}
        active={popoverActive}
        onClose={() => {
          return;
          //togglePopoverActive()
        }}
      >
        {getTag()}
      </Popover>
    </Wrap>
  );
}

export default DependantCell;
